import * as DeltaModule from "../../../node_modules/quill-delta/dist/Delta";

const Delta = DeltaModule;

export const AttributeMap = Delta.AttributeMap;
export const Op = Delta.Op;
export const OpIterator = Delta.OpIterator;
export default Delta;